import { css } from '@emotion/react'
import styled from '@emotion/styled'
import Image from '../components/Image'
import convertDatoImage, { ImageField } from '../utils/convertDatoImage'

const Title = styled.h1(({ theme }) => [
  css`
    ${theme.text.heading1(theme)};
  `,
])

const SublineItem = styled.span(({ theme }) => [
  css`
    position: relative;
    color: ${theme.colors.primaryBlue};

    &:not(:first-of-type) {
      margin-left: ${theme.spacing.x2}px;

      &::before {
        content: '';
        position: absolute;
        width: 4px;
        height: 4px;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
        background-color: ${theme.colors.neutral2};
        border-radius: 50%;
      }
    }
  `,
])

const Subline = styled.div(({ theme }) => [
  css`
    display: flex;
    margin-top: ${theme.spacing.x3}px;
  `,
])

const StyledImage = styled(Image)(
  ({ theme }) => css`
    width: 100%;
    height: auto;
    margin-top: ${theme.spacing.x3}px;
  `,
)

const Container = styled.div(
  css`
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  `,
)

const Section = styled.section(({ theme }) => [
  css`
    position: relative;
    padding: ${theme.spacing.x5}px ${theme.spacing.x2}px;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      padding: ${theme.spacing.x5}px ${theme.spacing.x4}px;
    }
  `,
])

interface Props {
  title: string
  subline?: Array<string>
  image?: ImageField
}

const MediaHeader = ({ title, subline, image }: Props) => {
  const formattedImage = (convertDatoImage(image) as ImageInfo) || null
  return (
    <Section>
      <Container>
        <Title>{title}</Title>
        {subline && subline?.length > 0 && (
          <Subline>
            {subline.map((item, index) => {
              const key = `${item.replaceAll(
                ' ',
                '',
              )}-${new Date().getTime()}-${index}`
              return <SublineItem key={key}>{item}</SublineItem>
            })}
          </Subline>
        )}
        {formattedImage && (
          <StyledImage
            src={formattedImage}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            alt={formattedImage.alt!}
            width={554}
            height={412}
          />
        )}
      </Container>
    </Section>
  )
}

export default MediaHeader
